<template>
  <div>
    <Head title="會員中心 - 收藏清單" />
    <notification-template title="會員中心">
      <template #header>收藏清單</template>
      <template v-if="$page.props.collection.length == 0">
        沒有任何收藏的項目
      </template>
      <template v-else>
        <div class="min-w-[375px] max-w-[1080px]">
          <div
            class="flex flex-wrap justify-center md:justify-start place-items-start"
          >
            <div
              v-for="product in $page.props.collection"
              :key="product.type + '_' + product.id"
              class="relative"
              @mouseenter="showDelete(product.type, product.id)"
              @mouseleave="hideDelete"
            >
              <Product
                class="max-w-[190px]"
                :show-quantity-input="true"
                price-tag="vertical"
                :price="product.price"
                :cv="product.cv"
                :type="product.type"
                :id="product.id"
                :name="product.name"
                :slug="product.slug"
                :quantity="product.quantity"
                :includes="product.includes"
                :attributes="product.attributes"
                :settings="product.settings"
                :images="product.images"
                :available="product.available"
              />
              <div
                v-if="
                  show_menu.type == product.type && show_menu.id == product.id
                "
                class="absolute top-0 right-0"
              >
                <Button
                  label="移除"
                  class="p-button-raised p-button-danger p-button-sm bg-fh-pink"
                  @click="removeFromCollection(product.type, product.id)"
                />
              </div>
            </div>
          </div>
        </div>
      </template>
    </notification-template>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Product from "../Products/Components/Product.vue";
import NotificationTemplate from "./Shared/NotificationTemplate";
import Button from "primevue/button";

export default {
  layout: Layout,
  components: {
    Product,
    NotificationTemplate,
    Button,
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      show_menu: {
        type: null,
        id: null,
      },
    };
  },
  methods: {
    showDelete(type, id) {
      this.show_menu = {
        type: type,
        id: id,
      };
    },
    hideDelete() {
      this.show_menu = {
        type: null,
        id: null,
      };
    },
    removeFromCollection(type, id) {
      this.$inertia.patch(route("user.collection"), {
        type: type,
        id: id,
      });
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        date.getDate().toString().padStart(2, "0") +
        " " +
        date.getHours().toString().padStart(2, "0") +
        ":" +
        date.getMinutes().toString().padStart(2, "0") +
        ":" +
        date.getSeconds().toString().padStart(2, "0")
      );
    },
    statusString(statusCode) {
      return this.$page.props.status_strings[statusCode];
    },
  },
};
</script>

<style lang="postcss">
.notification {
  @apply w-full px-2 py-4 mb-2 border border-fh-gray-border flex justify-between flex-wrap;
}

.notification .column {
  @apply flex flex-col;
}

.notification .column label {
  @apply text-xs;
}

.notification .column .detail {
  @apply text-sm;
}
</style>